import React from 'react';

/**
 * BubbleAura — wraps any bubble visual (img / orb) with applied cosmetics:
 *   - skin: 3-stop conic glow ring (from palette)
 *   - mood_burst: animated CSS aura (galaxy/rain/lightning/etc.)
 *   - eyes: layered overlay sitting on top of the image
 *
 * Reads `bubble.applied_cosmetics = { skin, mood_burst, eyes }` straight
 * from the backend payload — backend keys cosmetics by `kind`.
 */
const BubbleAura = ({ bubble, eyes = true, className = '', children }) => {
  const cosm = bubble?.applied_cosmetics || {};
  const skin = cosm.skin;
  const burst = cosm.mood_burst;
  const eyesC = cosm.eyes;

  const skinStyle = skin?.palette ? {
    '--skin-a': skin.palette[0],
    '--skin-b': skin.palette[1],
    '--skin-c': skin.palette[2],
  } : undefined;

  return (
    <div
      data-testid={`bubble-aura-${bubble?.id || 'x'}`}
      className={`aura-wrap aura-fill ${className}`}
      style={skinStyle}
    >
      {skin && <div className="skin-ring" />}
      {burst?.css && <div className={`aura-layer aura-${burst.css}`} />}
      {children}
      {eyes && eyesC && (
        <div className={`eyes-overlay ${eyesC.item_id ? `eyes-${eyesC.item_id.split('.')[1]}` : ''}`}>
          <span />
          <span />
        </div>
      )}
    </div>
  );
};

export default BubbleAura;
